export const formatInputValue = (value) => {
  if (!value) return "";

  // Remove non-letter characters (symbols, numbers)
  const lettersOnly = value.replace(/[^a-zA-Z]/g, "");

  // Remove only leading spaces, keep trailing + middle spaces
  const trimmedStart = lettersOnly.replace(/^\s+/, "");

  if (!trimmedStart) return "";

  // Capitalize the first character
  return trimmedStart.charAt(0).toUpperCase() + trimmedStart.slice(1);
};

export const formatInputValueWithSpace = (value) => {
  if (!value) return "";

  return value
    .replace(/^\s+/, "") // ❌ prevent leading spaces
    .replace(/\s+/g, " ") // ✅ allow only single spaces between words
    .toLowerCase()
    .split(" ")
    .map((word) => (word ? word[0].toUpperCase() + word.slice(1) : ""))
    .join(" ");
};

//permissions funtions
const getLoginData = () => {
  try {
    return JSON.parse(localStorage.getItem("login")) || {};
  } catch {
    return {};
  }
};
// Common helper: Super Admin check
const isSuperAdmin = () => {
  return Number(getLoginData()?.roleTypeID) === 1;
};

export const getPermissions = () => {
  try {
    return JSON.parse(localStorage.getItem("permissions")) || [];
  } catch {
    return [];
  }
};

export const hasViewPermission = (moduleName) => {
  if (isSuperAdmin()) return true;
  const permissions = getPermissions();

  return permissions.some(
    (item) =>
      item.moduleName === moduleName &&
      item.mActionName === "Can View" &&
      item.setDefaultAction === true
  );
};

export const hasAnyViewPermission = (moduleNames = []) => {
  if (isSuperAdmin()) return true;
  return moduleNames.some((name) => hasViewPermission(name));
};

//add update function
// export const hasModuleAction = (moduleName, actionName) => {
//   try {
//     const permissions = JSON.parse(localStorage.getItem("permissions")) || [];

//     if (!Array.isArray(permissions)) return false;

//     const matchedPermission = permissions.find(
//       (item) =>
//         item.moduleName?.toLowerCase() === moduleName?.toLowerCase() &&
//         item.mActionName?.toLowerCase() === actionName?.toLowerCase()
//     );

//     // Return based on setDefaultAction
//     return matchedPermission?.setDefaultAction === true;
//   } catch (error) {
//     console.error("Permission check error:", error);
//     return false;
//   }
// };

export const hasModuleAction = (moduleName, actionName) => {
  try {
    if (isSuperAdmin()) return true;

    const permissions = JSON.parse(localStorage.getItem("permissions")) || [];
    if (!Array.isArray(permissions)) return false;

    // //  Get login data
    // const loginData = JSON.parse(localStorage.getItem("login")) || {};
    // if (loginData?.roleTypeID === 1) {
    //   return true;
    // }

    // Action alias mapping
    const actionAliases = {
      "can delete": "can delete/change status",
    };

    const normalizedAction =
      actionAliases[actionName?.toLowerCase()] || actionName?.toLowerCase();

    const matchedPermission = permissions.find(
      (item) =>
        item.moduleName?.toLowerCase() === moduleName?.toLowerCase() &&
        item.mActionName?.toLowerCase() === normalizedAction
    );

    return matchedPermission?.setDefaultAction === true;
  } catch (error) {
    console.error("Permission check error:", error);
    return false;
  }
};
